import MenuItem from '@components/new/MenuItem';
import { TWbSeller } from "@api/apiClient/fbp";

export const WbSelectItem = ({ item, isSelected }: { item: TWbSeller, isSelected?: boolean }) => (
  <MenuItem
    title={item.name}
    description={`ID: ${item.wbId}`}
    active={isSelected}
  />
)

export const WbSelectValue = ({ item }: { item: TWbSeller | null }) => (
  <>{item?.name ?? ""}</>
)
